import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const NAV = [
  { to: "/about", label: "About" },
  { to: "/team", label: "Team" },
  { to: "/equipment", label: "Equipment" },
  { to: "/mrv", label: "MRV" },
  { to: "/services", label: "Services" },
  { to: "/learn", label: "Learn" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-paper border-b border-char-900/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between h-[72px]">
        <Link to="/" data-testid="logo-home-link" className="flex items-center group">
          <img
            src="https://customer-assets-4nw71qhi.emergentagent.net/job_site-creator-3339/artifacts/75kl3wxa_tanren-logo-light-bg.png"
            alt="Tanren"
            className="h-[47px] w-auto"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium tracking-tight transition-colors ${
                  isActive ? "text-ember" : "text-char-700 hover:text-char-900"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center">
          <Link
            to="/contact"
            data-testid="nav-contact-cta"
            className="btn-ember text-sm py-2.5 px-6"
          >
            Contact
            <ArrowUpRight size={16} />
          </Link>
        </div>

        <button
          type="button"
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-char-900"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-paper border-t border-char-900/10">
          <div className="px-6 py-6 flex flex-col gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-3 border-b border-char-900/10 font-display text-lg tracking-tight ${
                    isActive ? "text-ember" : "text-char-900"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}

            <Link
              to="/contact"
              data-testid="mobile-nav-contact-cta"
              className="btn-ember mt-6 justify-center"
            >
              Contact
              <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
